<div class="logo-sn ms-d-block-lg text-center">
  <a class="p-text-center block">
    <img src="../../../../assets/images/TS-Newlogo.png" alt="Logo" class="h-auto mt-2">
  </a>
</div>
<a class="no-underline" [href]="urlHref" target="_blank">
<p-tieredMenu [model]="items" (click)="activeMenu($event,'menu')" (contextmenu)="showMenu($event)"></p-tieredMenu>
</a>
